__turbopack_context__.v({
  "body": "ArticleListItem-module-scss-module__ETIDta__body",
  "header": "ArticleListItem-module-scss-module__ETIDta__header",
  "image": "ArticleListItem-module-scss-module__ETIDta__image",
  "link": "ArticleListItem-module-scss-module__ETIDta__link",
  "metaModules": "ArticleListItem-module-scss-module__ETIDta__metaModules",
  "teaserText": "ArticleListItem-module-scss-module__ETIDta__teaserText",
  "title": "ArticleListItem-module-scss-module__ETIDta__title",
  "wrapper": "ArticleListItem-module-scss-module__ETIDta__wrapper",
});
